import key from '../lib/constants'
import init from '../lib/initState'
import createReducer from '../lib/reducerConfig'

export const metamask = createReducer(init.metamask, {
  [key.SET_METAMASK] (state, action) {
    return action.payload
  }
})

export const userAuth = createReducer(init.userAuth, {
  [key.SET_USER_AUTHENTICATION] (state, action) {
    return action.payload
  }
})